import { Directive, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appTypewriter]',
  standalone: true
})
export class TypewriterDirective implements OnInit, OnDestroy {
  @Input('appTypewriter') text: string = '';
  @Input() speed: number = 100;
  @Input() pause: number = 2000; // Pause avant d'effacer
  
  private interval: any;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.startTypewriter();
  }

  private startTypewriter() {
    let isDeleting = false;
    let i = 0;
    let txt = '';

    this.interval = setInterval(() => {
      if (!isDeleting) {
        txt = this.text.substring(0, i + 1);
        i++;
      } else {
        txt = this.text.substring(0, i - 1);
        i--;
      }

      this.el.nativeElement.textContent = txt;

      if (!isDeleting && i === this.text.length) {
        isDeleting = true;
        clearInterval(this.interval);
        setTimeout(() => this.startTypewriter(), this.pause);
      } else if (isDeleting && i === 0) {
        isDeleting = false;
      }
    }, this.speed);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }
}